import * as React from "react";
import { Image } from "@wayflyer/flyui";

import type { UIElement } from "../utils/types";

import { PaidChannel } from "./paid-channels";

export type LogoProps = {
  name: PaidChannel;
};

const logoMap = {
  [PaidChannel.META_ADS]: "https://static.wayflyer.com/flyui-assets/images/meta.fc8308c02841.svg",
  [PaidChannel.GOOGLE_ADS]: "https://static.wayflyer.com/flyui-assets/images/insights-adworns.07f81ee177e5.svg",
};

export const Logo = (props: LogoProps): UIElement => {
  const { name } = props;
  const [src, setSrc] = React.useState("");

  const loadSvg = React.useCallback(() => {
    const logo = logoMap[name];
    setSrc(logo);
  }, [name]);

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- Existing violation after eslint-plugin-react-hooks v7 upgrade; remove when fixed.
    loadSvg();
  }, [loadSvg]);

  return <Image src={src} title={name} width={24} height={24} />;
};
